import { type PropsWithChildren } from "react";
import { useTranslations } from "use-intl";

import { IconTraveller } from "@/components/Icons";
import { CollapsibleCard } from "@/features/trips/components/CollapsibleCard";

type TravellerListItemProps = {
  name: string;
  additionalData?: string[];
};

export function TravellerListItem({
  name,
  additionalData,
}: TravellerListItemProps) {
  return (
    <li className="flex items-center gap-4 text-sm">
      <IconTraveller className="size-10 shrink-0 rounded-full bg-surface-background p-2" />

      <div className="flex flex-col">
        <span className="font-medium text-text-primary" data-sentry-mask>
          {name}
        </span>

        {additionalData ? (
          <span className="text-text-tertiary" data-sentry-mask>
            {additionalData
              .filter((x): x is NonNullable<typeof x> => Boolean(x))
              .map((item, index) => (
                <span key={index}>
                  {index > 0 ? <> &bull; </> : null}
                  {item}
                </span>
              ))}
          </span>
        ) : null}
      </div>
    </li>
  );
}

export function TravellerListCard({ children }: PropsWithChildren) {
  const t = useTranslations();

  return (
    <CollapsibleCard title={t("trips.travellerList.title")} collapsible={false}>
      <ul className="space-y-1">{children}</ul>
    </CollapsibleCard>
  );
}
